import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Image, Form, Button } from "semantic-ui-react";
import PhotoEditingJob from "~/models/PhotoEditing/PhotoEditingJob";

const SelectableImages = observer(
  ({ photoEditingJob, selectedImagesInfo, toggleSelectionCallback, selectAllCallback, unselectAllCallback }) => (
    <div>
      <Form style={{ paddingBottom: "10px" }}>
        <Button basic onClick={() => selectAllCallback(photoEditingJob.photoEditingJobId)}>
          Select All
        </Button>
        <Button basic onClick={() => unselectAllCallback(photoEditingJob.photoEditingJobId)}>
          Unselect All
        </Button>
      </Form>
      <Image.Group size="small">
        {photoEditingJob.photoEditingImages.map(({ photoEditingImageId, url }) => (
          <Image
            onClick={() => toggleSelectionCallback(photoEditingJob.photoEditingJobId, photoEditingImageId)}
            style={{
              cursor: "pointer",
              border: "2px solid",
              borderColor: selectedImagesInfo[photoEditingImageId] ? "#00abc7" : "grey",
              opacity: selectedImagesInfo[photoEditingImageId] ? "0.3" : "1",
            }}
            key={photoEditingImageId}
            bordered
            rounded
            src={url || "/www/img/no-image2.jpg"}
          />
        ))}
      </Image.Group>
    </div>
  ),
);

SelectableImages.propTypes = {
  photoEditingJob: PropTypes.instanceOf(PhotoEditingJob).isRequired,
  selectedImagesInfo: PropTypes.object.isRequired,
  toggleSelectionCallback: PropTypes.func.isRequired,
  selectAllCallback: PropTypes.func.isRequired,
  unselectAllCallback: PropTypes.func.isRequired,
};

export default SelectableImages;
